import React, { Component } from 'react'

export default class WorksGiostraPrimavera extends Component {
    render() {
        return (
            <div class="modal" id="worksgiostraprimavera" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-full" role="document">
                    <div class="modal-content">
                    <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
                        <div class="modal-header">
                            <h5 class="modal-title"><strong>“Giostra primavera”, romanzo Pequod 2018</strong></h5>
                            
                        </div>
                        <div class="modal-body p-4" id="result">



                            <div align="left">

                                <table border="0" cellpadding="20">
                                    <tr colspan="1" width="100%">
                                    </tr>
                                    <tr width="100%">

                                        <td width="50%">


                                            <br /> <br />

        

<br/>
                                        <strong>I protagonisti:</strong> Valeria e Alfredo. <br/>
                                    <strong>Il luogo: </strong>una cittadina balneare della riviera adriatica <br/>
                                <strong>Il tempo: </strong>un anno del terzo millennio, nei mesi che vanno dalla primavera all’apice della stagione estiva, in cui la riviera si popola e cambia volto insieme ai protagonisti.<br/>
<br/> <strong>La storia: </strong>lei, 35 anni, riflessiva e giudiziosa, il che rende i suoi slanci istintivi ancora più seducenti, si è trovata di colpo sulle spalle la responsabilità economica e morale di un albergo di famiglia, per cui deve prendere un’incresciosa decisione. Ha un  fratello che la osteggia, mentre le amiche di sempre le sono di poco aiuto. Lui, quarantenne, sceneggiatore, in passato anche troppo sicuro di sé ma adesso molto meno, appena tornato dopo un lungo periodo di lavoro nella capitale ha subito un lutto di cui si sente colpevole, e per questo soffre di una assurda ossessione. La figlia che studia all’estero è il suo unico vero affetto. Imprigionati ciascuno nella propria realtà, Valeria e Alfredo vivono come stretti in una morsa. Finché un giorno si incontrano e da quel momento cominciano a intravedere uno spiraglio, una chance per ritrovare se stessi e rimettersi in gioco. Il tormentato sentimento che li avvince sembra la sola forza capace di riportarli alla vita, ma hanno contro un nemico che marcia nelle loro stesse scarpe…
<br/><strong>Possibile chiave di lettura:</strong> una dichiarazione di guerra al cinismo.
                    
                    
                    
                    
<br />

                    <strong>ne hanno scritto:</strong> <br /><br />

                    <ul>

                        <li><a href="rec/giostraprimavera/adige.pdf" target="_blank" >Fabrizio Franchi, in l’Adige, 1/11/2018</a></li>
                        <li><a href="rec/giostraprimavera/CorrierediRomagna.pdf" target="_blank" >Gaia Matteini, in Corriere di Romagna, 21/11/2018</a></li>
                            <li>Carlo Martinelli, in Trentino e in Alto Adige, 9/12/2018</li>
                            <li><a href="rec/giostraprimavera/restocarlino.pdf" target="_blank" >Lina Colasanto, in Il Resto del Carlino, 3/1/2019</a></li>
                            <li>Roberto Carnero, in Famiglia cristiana, 27/1/2019</li>
                            <li>Corriere Romagna, 3/1/2019</li>
                            <li>Felice Cimatti, a Fahrenheit, Il libro del giorno, 31/12/2018</li>
                            <li>Fuoriasse – Officina della cultura, Rivista culturale on line, n. 23, dicembre 2018</li>



            
</ul>







</td >


</tr>
</table>
</div >



















            </div >
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
        </div >
    </div >
</div >


    )
    }
}
